// RouterWrapper.jsx
import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Success from "./Success";
import Cancel from "./Cancel";

export default function RouterWrapper({ children }) {
  return (
    <Router>
      <Routes>
        {/* ✅ Page Stripe */}
        <Route path="/success" element={<Success />} />
        <Route path="/cancel"  element={<Cancel />} />

        {/* ✅ Toutes les autres routes reviennent à ton App "classique" */}
        <Route path="*" element={children} />
      </Routes>
    </Router>
  );
}
